import Vue from 'vue';
import {api, calendar_api} from "@/store/resources";

export default {
    namespaced: true,
    state: {
        monthSelected: null,
        dateSelected: null,
        calendarData: [],
        transactions: {
            data: [],
            dirty: false,
            moreLoading: false,
            pagination: {
                current_page: 1,
                pages: null
            }
        },
        datePlannedTransactions: {
            data: [],
            dirty: false,
            moreLoading: false,
            pagination: {
                current_page: 1,
                pages: null
            }
        }
    },
    getters: {
        calendarData: (state) => state.calendarData
    },
    actions: {
        async fetchCalendar({commit, state, rootState}) {
            try {
                const month = state.monthSelected.split('-')[1],
                    year = state.monthSelected.split('-')[0];
                const res = await calendar_api.fetchMonth.get({
                    month, year,
                    space_id: rootState.space.current_space.data.id
                });
                if (res.body.success) {
                    commit('setCalendarData', res.body.data)
                } else {
                    console.error(res);
                }
            } catch (err) {
                console.error(err)
            }
        },
        async onMonthChanged({dispatch, commit}, date) {
            commit('selectMonth', date);
            await dispatch('fetchCalendar');
        },
        async fetchTransactions({commit, state, rootState}) {
            commit('setTransactionsDirty')
            commit('setTransactionsPage', 1);

            try {
                const query = {
                    space_id: rootState.space.current_space.data.id,
                    date_start: Vue.prototype.$moment(state.dateSelected, 'YYYY-MM-DD').startOf('day').unix(),
                    date_end: Vue.prototype.$moment(state.dateSelected, 'YYYY-MM-DD').endOf('day').unix(),
                    page: state.transactions.pagination.current_page
                };
                const res = await api.transactions.get(query)
                if (res.body.success) {
                    commit('setTransactions', res.body);
                } else {
                    console.log(res)
                }
            } catch (err) {
                console.error(err)
            }
        },
        async fetchMoreTransactions({commit, state, rootState}) {
            commit('setTransactionsMoreLoading')
            try {
                const query = {
                    space_id: rootState.space.current_space.data.id,
                    date_start: Vue.prototype.$moment(state.dateSelected, 'YYYY-MM-DD').startOf('day').unix(),
                    date_end: Vue.prototype.$moment(state.dateSelected, 'YYYY-MM-DD').endOf('day').unix(),
                    page: state.transactions.pagination.current_page
                }

                const res = await api.transactions.get(query)
                if (res.body.success) {
                    commit('pushTransactions', res.body);
                } else {
                    console.log(res)
                }
            } catch (e) {
                console.log(e)
            }
        },

        async fetchPlannedTransactions({commit, state, rootState}) {
            commit('setPlannedTransactionsDirty')
            commit('setPlannedTransactionsPage', 1);

            try {
                const query = {
                    space_id: rootState.space.current_space.data.id,
                    date: state.dateSelected,
                    page: state.datePlannedTransactions.pagination.current_page
                };
                const res = await calendar_api.plannedTransactions.get(query)
                if (res.body.success) {
                    commit('setPlannedTransactions', res.body);
                } else {
                    console.log(res)
                }
            } catch (err) {
                console.error(err)
            }
        },
        async fetchMorePlannedTransactions({commit, state, rootState}) {
            commit('setPlannedTransactionsMoreLoading')
            try {
                const query = {
                    space_id: rootState.space.current_space.data.id,
                    date: state.dateSelected,
                    page: state.datePlannedTransactions.pagination.current_page
                }

                const res = await calendar_api.plannedTransactions.get(query)
                if (res.body.success) {
                    commit('pushPlannedTransactions', res.body);
                } else {
                    console.log(res)
                }
            } catch (e) {
                console.log(e)
            }
        },
        confirmPlannedTransaction({}, id) {
            const payload = {
                timezone: Vue.prototype.$moment.tz.guess()
            }
            return calendar_api.confirmPlannedTransaction.save({id}, payload);
        },
        resetCalendar({commit}) {
            commit('setCalendarData', []);
            commit('selectMonth', null);
            commit('clearTransactions');
            commit('clearPlannedTransactions');
        }
    },
    mutations: {
        selectDate(state, date) {
            state.dateSelected = date;
        },
        selectMonth(state, date) {
            state.dateSelected = null;
            state.monthSelected = date;
        },
        setCalendarData(state, data) {
            state.calendarData = data;
        },

        setTransactionsDirty(state) {
            state.transactions.dirty = true;
        },
        setTransactionsMoreLoading(state) {
            state.transactions.moreLoading = true;
        },
        setTransactions(state, payload) {
            state.transactions.data = payload.data.rows;
            state.transactions.pagination.pages = Math.ceil(payload.data.length / 20);
            state.transactions.dirty = false;
        },
        pushTransactions(state, payload) {
            state.transactions.data.push(...payload.data.rows)
            state.transactions.moreLoading = false;
        },
        setTransactionsPage(state, num) {
            state.transactions.pagination.current_page = num;
        },
        clearTransactions(state) {
            state.transactions = {
                data: [],
                dirty: false,
                moreLoading: false,
                pagination: {
                    current_page: 1,
                    pages: null
                }
            }
        },

        setPlannedTransactionsDirty(state) {
            state.datePlannedTransactions.dirty = true;
        },
        setPlannedTransactionsPage(state, num) {
            state.datePlannedTransactions.pagination.current_page = num;
        },
        setPlannedTransactions(state, payload) {
            state.datePlannedTransactions.data = payload.data.rows;
            state.datePlannedTransactions.pagination.pages = Math.ceil(payload.data.length / 20);
            state.datePlannedTransactions.dirty = false;
        },
        setPlannedTransactionsMoreLoading(state) {
            state.transactions.moreLoading = true;
        },
        pushPlannedTransactions(state, payload) {
            state.transactions.data.push(...payload.data.rows)
            state.transactions.moreLoading = false;
        },
        clearPlannedTransactions(state) {
            state.datePlannedTransactions = {
                data: [],
                dirty: false,
                moreLoading: false,
                pagination: {
                    current_page: 1,
                    pages: null
                }
            }
        },
    },
}